var map = {
	"./background-modal.svg": "2aca",
	"./create.svg": "6ab00",
	"./document-accept.svg": "87c3",
	"./document-equall.svg": "ff06",
	"./document-refused.svg": "fbb8",
	"./equall.svg": "5b9a",
	"./refused.svg": "05fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b4a9";